import { component_tool, framework_tool, utils_tool } from '@/tool';
import React from 'react';
import { WizAuthority } from "@/containers/common";
import { AudienceGroupItem } from '@/components';
let { WizModal,WizButton } = component_tool;
let ref
//配置项
let componentName = 'thirdAppSetting'

export default (self) => {

  let result = [
    {
      title: 'id',
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: "管理权限",
      name: "authInfo",
      formItem: {
        type: "diy",
        diy: WizAuthority,
        mode: 'Form',
        // onChange:_onchange,
        hasRadioGroup:false,
        keys: ["orgIds", "positionIds", "positionCategoryIds"]
      },
    },
    
    {
      title: '受众信息',
      name: 'authInfo',
      tableItem: {
        render: (text, record) => {
          return <AudienceGroupItem key={record?.id} personIds={[]} orgIds={record?.authInfo?.orgIds||[]} positionCategoryIds={record?.authInfo?.positionCategoryIds||[]} positionIds = {record?.authInfo?.positionIds||[]}  /> 
    
        }
      }
    },

    {
      title: '操作',
      key: 'action',
      tableItem: {
      render: (text, record) => (
        <WizButton type="link" className="button" onClick={self.editSetting.bind(self, record)}>编辑</WizButton>
      ),
      }
    },
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    
    
  ]
  return result
}

